import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "message-timestamp"
};
import { toRefs, ref, watch } from '../../../../adapter-vue';
import { TUITranslateService } from '@tencentcloud/chat-uikit-engine';
export default /*@__PURE__*/_defineComponent({
  __name: 'message-timestamp',
  props: {
    currTime: {
      type: Number,
      default: 0
    },
    prevTime: {
      type: Number,
      default: 0
    }
  },
  setup(__props) {
    var props = __props;
    var {
      currTime,
      prevTime
    } = toRefs(props);
    var timestampShowFlag = ref(false);
    var timestampShowContent = ref('');
    var handleItemTime = (currTime, prevTime) => {
      timestampShowFlag.value = false;
      if (currTime <= 0) {
        return '';
      } else if (!prevTime || prevTime <= 0) {
        timestampShowFlag.value = true;
        return calculateTimestamp(currTime * 1000);
      } else {
        var minDiffToShow = 10 * 60; // 10min 10*60s
        var diff = currTime - prevTime; // s
        if (diff >= minDiffToShow) {
          timestampShowFlag.value = true;
          return calculateTimestamp(currTime * 1000);
        }
      }
      return '';
    };
    watch(() => [currTime.value, prevTime.value], (newVal, oldVal) => {
      if ((newVal === null || newVal === void 0 ? void 0 : newVal.toString()) === (oldVal === null || oldVal === void 0 ? void 0 : oldVal.toString())) {} else {
        timestampShowContent.value = handleItemTime(currTime.value, prevTime.value);
      }
    }, {
      immediate: true
    });
    // 计算时间戳函数
    // calculate timestamp
    function calculateTimestamp(timestamp) {
      var todayZero = new Date().setHours(0, 0, 0, 0);
      var thisYear = new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0).getTime();
      var target = new Date(timestamp);
      // 重写时间处理
      var datetime = new Date();
      datetime.setTime(timestamp);
      var Y = datetime.getFullYear();
      var M = datetime.getMonth() + 1 < 10 ? '0' + (datetime.getMonth() + 1) : datetime.getMonth() + 1;
      var D = datetime.getDate() < 10 ? '0' + datetime.getDate() : datetime.getDate();
      var h = datetime.getHours() < 10 ? '0' + datetime.getHours() : datetime.getHours();
      var m = datetime.getMinutes() < 10 ? '0' + datetime.getMinutes() : datetime.getMinutes();
      var oneDay = 24 * 60 * 60 * 1000;
      var oneWeek = 7 * oneDay;
      var diff = todayZero - target.getTime();
      function formatNum(num) {
        return num < 10 ? '0' + num : num.toString();
      }
      if (diff <= 0) {
        // today, only display hour:minute
        // return `${formatNum(target.getHours())}:${formatNum(target.getMinutes())}`
        return "".concat(h, ":").concat(m);
      } else if (diff <= oneDay) {
        // yesterday, display yesterday:hour:minute
        // return `${TUITranslateService.t('time.昨天')} ${formatNum(
        //   target.getHours()
        // )}:${formatNum(target.getMinutes())}`
        return "".concat(TUITranslateService.t('time.昨天')).concat(h, ":").concat(m);
      } else if (diff <= oneWeek - oneDay) {
        return "".concat(M, "-").concat(D, " ").concat(h, ":").concat(m);
        // Within a week, display weekday hour:minute
        // const weekdays = [
        //   '星期日',
        //   '星期一',
        //   '星期二',
        //   '星期三',
        //   '星期四',
        //   '星期五',
        //   '星期六'
        // ]
        // const weekday = weekdays[target.getDay()]
        // return `${TUITranslateService.t('time.' + weekday)} ${formatNum(
        //   target.getHours()
        // )}:${formatNum(target.getMinutes())}`
      } else if (target.getTime() >= thisYear) {
        // Over a week, within this year, display mouth/day hour:minute
        return "".concat(M, "-").concat(D, " ").concat(h, ":").concat(m);
        // return `${target.getMonth() + 1}/${target.getDate()} ${formatNum(
        //   target.getHours()
        // )}:${formatNum(target.getMinutes())}`
      } else {
        // Not within this year, display year/mouth/day hour:minute
        // return `${target.getFullYear()}/${target.getMonth() + 1
        //   }/${target.getDate()} ${formatNum(target.getHours())}:${formatNum(
        //     target.getMinutes()
        //   )}`
        return "".concat(Y, "-").concat(M, "-").concat(D, " ").concat(h, ":").concat(m);
      }
    }
    return (_ctx, _cache) => {
      return _unref(timestampShowFlag) ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(timestampShowContent)), 1)) : _createCommentVNode("", true);
    };
  }
});